import React, { FunctionComponent } from 'react';
import moment from 'moment';
import { meetingTasksPageSelectors } from '../../../../../../../../app/page/page-storage/meeting-tasks/meeting-tasks.selectors';
import { ISimpleTasks } from '../../../../../../../../app/page/page-storage/tasks-simple/tasks-simple.types';
import { useSelect, useSelectWithParams } from '../../../../../../../../utils/selector.utils';
import { BoardListHeader } from './BoardListHeader';
import { BoardListTasks } from './BoardListTasks';
import { FilteredTasks, IBoardListProps } from './types';
import { taskSimpleSelectors } from '../../../../../../../../app/resource/task-simple/task-simple.selectors';
import { boardTasksSelectors } from '../../../../../../../../app/page/boards/boards.selectors';

export const BoardList: FunctionComponent<IBoardListProps> = ({ meetingId, boardListId }) => {
  const filterText = useSelect(boardTasksSelectors.selectFreetextValue);
  const dueDateFilter = useSelect(boardTasksSelectors.selectFilterDate);
  const memberIds = useSelect(boardTasksSelectors.selectFilterMemberIds);

  const meetingTasks = useSelect(meetingTasksPageSelectors.selectMeetingTasks)[meetingId];
  const boardListTasks = meetingTasks
    ? (((meetingTasks.boardTasks[Number(boardListId)] as unknown) ?? {
        active: [],
        done: [],
      }) as ISimpleTasks)
    : { active: [], done: [] };

  const activeBoardTasks = useSelectWithParams(taskSimpleSelectors.selectResourcesById, boardListTasks.active);

  if (meetingTasks === undefined || meetingTasks === null) {
    return null;
  }

  const filteredTasks: FilteredTasks = {
    textFilteredTasks: [],
    dueDateFilteredTasks: [],
    memberFilteredTasks: [],
  };

  activeBoardTasks.map((task) => {
    const lowerCaseFilterText = filterText.toLowerCase();
    const dueDate = moment(dueDateFilter).format('YYYY-MM-DD');
    if (task) {
      const title = task.title.toLowerCase();
      const description = task.description.toLowerCase();

      const titleArr = title.split(' ');
      const filterArr = lowerCaseFilterText.split(' ');
      const filteredWords = filterArr.filter((word) => word !== '');

      if (dueDate && task.dueDate !== undefined && dueDate + 1 >= task.dueDate) {
        filteredTasks.dueDateFilteredTasks.push(task.id);
      }
      if (task.members.length > 0 && task.members.some((id) => memberIds.includes(id))) {
        filteredTasks.memberFilteredTasks.push(task.id);
      }
      if (
        title.includes(lowerCaseFilterText) ||
        description.includes(lowerCaseFilterText) ||
        filteredWords.some((word) => titleArr.includes(word))
      ) {
        filteredTasks.textFilteredTasks.push(task.id);
      } else {
        return task;
      }
    }
    return filteredTasks;
  });

  const handleFilters = () => {
    if (memberIds.length > 0 && !filterText && !dueDateFilter) {
      return filteredTasks.memberFilteredTasks;
    }
    if (dueDateFilter) {
      return filteredTasks.dueDateFilteredTasks;
    } else {
      return filteredTasks.textFilteredTasks;
    }
  };

  return (
    <div className="single-card-container">
      <div className="panel-body px-0">
        <div className="border-radius-1 lightGray-bg px-2 pb-1">
          <BoardListHeader boardListId={boardListId} meetingId={meetingId} />
          <BoardListTasks
            activeIds={handleFilters()}
            doneIds={boardListTasks.done}
            taskTypeId={boardListId}
            meetingId={meetingId}
          />
        </div>
      </div>
    </div>
  );
};
